<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>{{type==0?'添加内部合伙人':'编辑内部合伙人'}}
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :rules="rules" :model="formdata" label-width="180px" id="recruitCompany">
          <!-- <el-form-item label="选择员工" prop="activity">
            <el-button  @click="dialogActivity = true">选择员工</el-button>
          <div>
            <el-tag type="info" v-for="item in activity" :key="item.eid">{{item.title}}</el-tag>
          </div>
          </el-form-item> -->
          <el-form-item label="选择员工">
            <div class="goodsType">
                      <template v-if="activity.length>0">
                        <span v-for="(item,index) in activity" :key="index">
                          {{item.title}}
                        </span>                        
                      </template>  
                     <template v-else>
                       {{defaultName}}
                      </template>
            </div>
            <el-button size="small" @click="dialogActivity = true">选择员工</el-button>
          </el-form-item>
          <el-form-item label="是否可消费" prop="is_discount">
          <el-radio-group v-model="formdata.is_discount">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
          <el-form-item label="充值金额" prop="balance" v-if="type==0">
            <el-input type="text" v-model="formdata.balance" placeholder="请填写金额" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="续充金额" prop="balance" v-if="type==1">
            <el-input type="text" v-model="formdata.balance" placeholder="请填写金额" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="bank_card">
            <el-input type="text" v-model="formdata.bank_card" placeholder="请填写卡号" class="w340"></el-input>
          </el-form-item>
           <el-form-item label="户名" prop="bank_username">
            <el-input type="text" v-model="formdata.bank_username" placeholder="请填写户名" class="w340"></el-input>
          </el-form-item>
           <el-form-item label="开户行" prop="bank_name">
            <el-input type="text" v-model="formdata.bank_name" placeholder="请填写开户行" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="到期时间" prop="expire_time">
            <el-date-picker v-model="formdata.expire_time" type="date" placeholder="请选择到期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formdata.remark" placeholder="请输入" class="w340"></el-input>
          </el-form-item>
          <el-form-item v-if="type==0">
            <el-button type="primary" @click="onGetQrcode">生成二维码</el-button>
            <el-button @click="goback">取消</el-button>
          </el-form-item>
          <el-form-item v-if="type==1">
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="goback">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <shenheDialog :visible.sync="dialogActivity" @updatePageInfo="updatePageInfo"></shenheDialog>
    <merchantQrcodeDialog2 :visible.sync="dialogQrcode" :property="qrResult"></merchantQrcodeDialog2>
  </div>
</template>
<script>
  import api from "@/api.js";
  import shenheDialog from '@/components/tkdialog/shenheDialog';
  import merchantQrcodeDialog2 from '@/components/tkdialog/merchantQrcodeDialog2';
  export default {
    name: "addPartner",
    components: {
      shenheDialog,
      merchantQrcodeDialog2
    },
    data() {
      return {
        formdata: {
          partner_id:'',
          balance: "",
          bank_card: "",
          bank_username: "",
          bank_name: "",
          expire_time: "",
          remark: "",
          eid: "",
          release: '',
        },
        lock: true,
        is_discount: 1,
        choosedepdialog: false,
        editInfo: '',
        eid:[],
        qrResult:{},
        defaultName:'',
        activity : [],//员工列表
        partmentListId:[],
        pageoption: this.$route.query,
        dialogActivity: false,
        dialogQrcode: false,
        rules: {
          balance: [{required: true, message: "请输入金额", trigger: "blur"}],
          bank_card: [{required: true, message: "请输入银行卡号", trigger: "blur"}],
          bank_username: [
            {required: true, message: "请输入户名", trigger: "blur"}
          ],
          bank_name: [
            {required: true, message: "请输入开户行", trigger: "blur"}
          ],
          expire_time: [
            {required: true, message: "请输入到期时间", trigger: "blur"}
          ]
        }
      };
    },
    created() {
      this.type = this.$route.query.type;
      this.InitFn()
    },
    methods: {
      InitFn() {
        if (this.pageoption.id) {
          this.axios
              .post(api.partner_detail, {partner_id: this.pageoption.id})
              .then(response => {
                if (response.data.code == 0) {
                  this.formdata = response.data.result;
                  this.defaultName = response.data.result.name;
                } else {
                }
              })
              .catch(response => {
              });
        }
      },
     
      onGetQrcode() {
        if (!this.formdata.balance) {
          this.$message.error('请填写金额');
          return
        }
        if (!this.formdata.bank_card) {
          this.$message.error('请填写卡号');
          return
        }
        if (!this.formdata.bank_username) {
          this.$message.error('请填写户名');
          return
        }
        if (!this.formdata.bank_name) {
          this.$message.error('请填写开户行');
          return
        }
        if (!this.formdata.expire_time) {
          this.$message.error('请选到期时间');
          return
        }
      
        let url_ = api.partnerAdd 
        let data_ = this.formdata
        // let title = '添加合伙人成功'
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.qrResult = response.data.result;
                this.dialogQrcode = true;
                this.defaultName = '';
                this.$message({
                  message: "生成二维码成功",
                  type: "success"
                });
                // this.$message({
                //   showClose: true,
                //   message: title,
                //   type: 'success',
                //   center: true
                // });
                // this.$router.go(-1)
              } else {
              }
            })
            .catch(response => {
            });
      },
      onSubmit() {
      let data_ = this.formdata
      let title = '编辑成功！' // type_ 0 添加 1 编辑
      let url_ = api.partner_edit
      data_.partner_id = this.pageoption.id
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.defaultName = '';
                this.$message({
                  showClose: true,
                  message: title,
                  center: true
                });
                this.$router.go(-1)
              } else {
              }
            })
            .catch(response => {
            });
    },
      updatePageInfo(option) {
      this.activity = option;
      let arr = [];
      for (let i = 0; i < option.length; i++) {
        arr.push(option[i].id);
      }
      // this.formdata.eid = arr.join(',');
      this.formdata.eid = arr[0];
    },
    onChange(e) {
      this.formdata.eid = e;
    },
      goback() {
        this.$router.go(-1);
      },
    }
  };
</script>
<style>
  #recruitCompany .el-form-item{
    margin-bottom: 22px;
  }
</style>

